import Employees from './Employees';

/**
 * EmployeesPage - Page wrapper for the Employees list view
 * 
 * All necessary providers (Customer, Services, Business, Jobs, Employees)
 * are provided at the route level in App.tsx
 */
export default function EmployeesPage() {
  return (
    <div className="employee-detail-page">
      <Employees />
    </div>
  );
}